var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CallLogsEmptyView from '../components/CallLogs/EmptyView.vue';
import CallLogsTimelineView from '../components/CallLogs/TimelineView.vue';
import { Talent } from 'packages/talent/entities/Talent';
var callLogsModule = namespace('callLogs');
var talentCardModule = namespace('talentCard');
var CallLogsIndex = /** @class */ (function (_super) {
    __extends(CallLogsIndex, _super);
    function CallLogsIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    var _a;
    __decorate([
        callLogsModule.State('isFetching'),
        __metadata("design:type", Boolean)
    ], CallLogsIndex.prototype, "loading", void 0);
    __decorate([
        callLogsModule.State,
        __metadata("design:type", Array)
    ], CallLogsIndex.prototype, "callLogs", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], CallLogsIndex.prototype, "talent", void 0);
    CallLogsIndex = __decorate([
        Component({
            components: {
                CallLogsEmptyView: CallLogsEmptyView,
                CallLogsTimelineView: CallLogsTimelineView,
            },
        })
    ], CallLogsIndex);
    return CallLogsIndex;
}(Vue));
export default CallLogsIndex;
